import TextsOnly from 'containers/Slices/TextsOnly';
import ImageWithTitle from 'containers/Slices/ImageWithTitle';
import TwoColumns from 'containers/Slices/TwoColumns';
import AuxBanner from 'containers/Slices/AuxBanner';
import HTMLTextsOnly from 'containers/Slices/HTMLTextsOnly';
import JobsBlock from 'containers/Slices/JobsBlock';
import HolidayOffers from 'containers/Slices/HolidayOffers';

const renderAuxSlices = (block, type, index) => {
  switch (type) {
    case 'texts_only':
      return <TextsOnly block={block} key={`${type}-${index}`} />;
    case 'html_text_only':
      return <HTMLTextsOnly block={block} key={`${type}-${index}`} />;
    case 'two_columns':
      return <TwoColumns block={block} key={`${type}-${index}`} />;
    case 'image_with_title':
      return <ImageWithTitle block={block} key={`${type}-${index}`} />;
    case 'aux_banner':
      return <AuxBanner block={block} key={`${type}-${index}`} />;
    case 'jobs_block':
      return <JobsBlock block={block} key={`${type}-${index}`} />;
    case 'holiday_offers':
      return <HolidayOffers block={block} key={`${type}-${index}`} />;
    default:
      return '';
  }
};

export default renderAuxSlices;
